module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _vm._m(0)
},staticRenderFns: [function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "chapter"
  }, [_c('div', {
    staticClass: "inner_page"
  }, [_c('section', {
    staticClass: "SOM",
    attrs: {
      "epub:type": "toc"
    }
  }, [_c('h1', {
    staticClass: "SOM_titre",
    attrs: {
      "epub:type": "title"
    }
  }, [_vm._v("Contents")]), _vm._v(" "), _c('div', {
    staticClass: "SOM_pdd"
  }, [_c('span', {
    attrs: {
      "href": "#/pagetitre",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("Title Page")])]), _vm._v(" "), _c('div', {
    staticClass: "SOM_pdd"
  }, [_c('span', {
    attrs: {
      "href": "#/ident1#collec",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("What others are saying about Frank Viscuso")])]), _vm._v(" "), _c('div', {
    staticClass: "SOM_pdd"
  }, [_c('span', {
    attrs: {
      "href": "#/ident11#copy1",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("Copyright Page")])]), _vm._v(" "), _c('div', {
    staticClass: "SOM_pre"
  }, [_c('a', {
    attrs: {
      "href": "#/pre2"
    }
  }, [_vm._v("Acknowledgements")])]), _vm._v(" "), _c('div', {
    staticClass: "SOM_chap"
  }, [_c('a', {
    attrs: {
      "href": "#/chap1"
    }
  }, [_vm._v("1 - A Leader of One")])]), _vm._v(" "), _c('div', {
    staticClass: "SOM_niv1"
  }, [_c('a', {
    attrs: {
      "href": "#/chap1#niv1-001"
    }
  }, [_vm._v("It's Time")])]), _vm._v(" "), _c('div', {
    staticClass: "SOM_niv1"
  }, [_c('a', {
    attrs: {
      "href": "#/chap1#niv1-002"
    }
  }, [_vm._v("The Best Teacher")])]), _vm._v(" "), _c('div', {
    staticClass: "SOM_niv1"
  }, [_c('a', {
    attrs: {
      "href": "#/chap1#niv1-003"
    }
  }, [_vm._v("Who's in charge?")])]), _vm._v(" "), _c('div', {
    staticClass: "SOM_niv1"
  }, [_c('a', {
    attrs: {
      "href": "#/chap1#niv1-004"
    }
  }, [_vm._v("No one trained me!")])]), _vm._v(" "), _c('div', {
    staticClass: "SOM_niv1"
  }, [_c('a', {
    attrs: {
      "href": "#/chap1#niv1-005"
    }
  }, [_vm._v("Permission to Lead")])]), _vm._v(" "), _c('div', {
    staticClass: "SOM_niv1"
  }, [_c('a', {
    attrs: {
      "href": "#/chap1#niv1-006"
    }
  }, [_vm._v("Leadership Lessons from the Fire Service")])]), _vm._v(" "), _c('div', {
    staticClass: "SOM_niv1"
  }, [_c('a', {
    attrs: {
      "href": "#/chap1#niv1-007"
    }
  }, [_vm._v("It's not about you")])]), _vm._v(" "), _c('div', {
    staticClass: "SOM_niv1"
  }, [_c('a', {
    attrs: {
      "href": "#/chap1#niv1-008"
    }
  }, [_vm._v("The Mission")])]), _vm._v(" "), _c('div', {
    staticClass: "SOM_niv1"
  }, [_c('a', {
    attrs: {
      "href": "#/chap1#niv1-009"
    }
  }, [_vm._v("A New Generation of Leaders")])]), _vm._v(" "), _c('div', {
    staticClass: "SOM_niv1"
  }, [_c('a', {
    attrs: {
      "href": "#/chap1#niv1-010"
    }
  }, [_vm._v("Managers versus Leaders")])]), _vm._v(" "), _c('div', {
    staticClass: "SOM_niv1"
  }, [_c('a', {
    attrs: {
      "href": "#/chap1#niv1-011"
    }
  }, [_vm._v("Step Up")])]), _vm._v(" "), _c('div', {
    staticClass: "SOM_chap"
  }, [_c('span', {
    attrs: {
      "href": "#/chap2",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("2 - Leadership Traits")])]), _vm._v(" "), _c('div', {
    staticClass: "SOM_niv1"
  }, [_c('span', {
    attrs: {
      "href": "#/chap2#niv1-012",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("Loyal")])]), _vm._v(" "), _c('div', {
    staticClass: "SOM_niv1"
  }, [_c('span', {
    attrs: {
      "href": "#/chap2#niv1-013",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("Educated")])]), _vm._v(" "), _c('div', {
    staticClass: "SOM_niv1"
  }, [_c('span', {
    attrs: {
      "href": "#/chap2#niv1-014",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("Adaptable")])]), _vm._v(" "), _c('div', {
    staticClass: "SOM_niv1"
  }, [_c('span', {
    attrs: {
      "href": "#/chap2#niv1-015",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("Determined")])]), _vm._v(" "), _c('div', {
    staticClass: "SOM_niv1"
  }, [_c('span', {
    attrs: {
      "href": "#/chap2#niv1-016",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("Enthusiastic")])]), _vm._v(" "), _c('div', {
    staticClass: "SOM_niv1"
  }, [_c('span', {
    attrs: {
      "href": "#/chap2#niv1-017",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("Reliable")])]), _vm._v(" "), _c('div', {
    staticClass: "SOM_niv1"
  }, [_c('span', {
    attrs: {
      "href": "#/chap2#niv1-018",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("Selfless")])]), _vm._v(" "), _c('div', {
    staticClass: "SOM_niv1"
  }, [_c('span', {
    attrs: {
      "href": "#/chap2#niv1-019",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("Tough")])]), _vm._v(" "), _c('div', {
    staticClass: "SOM_niv1"
  }, [_c('span', {
    attrs: {
      "href": "#/chap2#niv1-020",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("Empathetic")])]), _vm._v(" "), _c('div', {
    staticClass: "SOM_niv1"
  }, [_c('span', {
    attrs: {
      "href": "#/chap2#niv1-021",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("Assertive")])]), _vm._v(" "), _c('div', {
    staticClass: "SOM_niv1"
  }, [_c('span', {
    attrs: {
      "href": "#/chap2#niv1-022",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("Courageous")])]), _vm._v(" "), _c('div', {
    staticClass: "SOM_niv1"
  }, [_c('span', {
    attrs: {
      "href": "#/chap2#niv1-023",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("Honorable")])]), _vm._v(" "), _c('div', {
    staticClass: "SOM_niv1"
  }, [_c('span', {
    attrs: {
      "href": "#/chap2#niv1-024",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("Leaders Teach")])]), _vm._v(" "), _c('div', {
    staticClass: "SOM_niv1"
  }, [_c('span', {
    attrs: {
      "href": "#/chap2#niv1-025",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("Leadership Failure")])]), _vm._v(" "), _c('div', {
    staticClass: "SOM_niv1"
  }, [_c('span', {
    attrs: {
      "href": "#/chap2#niv1-026",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("Legacy of a Leader")])]), _vm._v(" "), _c('div', {
    staticClass: "SOM_chap"
  }, [_c('span', {
    attrs: {
      "href": "#/chap3",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("3 - Leadership Skills")])]), _vm._v(" "), _c('div', {
    staticClass: "SOM_niv1"
  }, [_c('span', {
    attrs: {
      "href": "#/chap3#niv1-027",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("Talent, Skills, and Abilities")])]), _vm._v(" "), _c('div', {
    staticClass: "SOM_niv1"
  }, [_c('span', {
    attrs: {
      "href": "#/chap3#niv1-028",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("Delegation")])]), _vm._v(" "), _c('div', {
    staticClass: "SOM_niv1"
  }, [_c('span', {
    attrs: {
      "href": "#/chap3#niv1-029",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("How to Delegate")])]), _vm._v(" "), _c('div', {
    staticClass: "SOM_niv2"
  }, [_c('span', {
    attrs: {
      "href": "#/chap3#niv2-029",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("1. Establish and maintain an environment that is favorable to delegating.")])]), _vm._v(" "), _c('div', {
    staticClass: "SOM_niv2"
  }, [_c('span', {
    attrs: {
      "href": "#/chap3#niv2-030",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("2. Select the right person for the job.")])]), _vm._v(" "), _c('div', {
    staticClass: "SOM_niv2"
  }, [_c('span', {
    attrs: {
      "href": "#/chap3#niv2-031",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("3. Ensure that the person accepting the assignment understands it.")])]), _vm._v(" "), _c('div', {
    staticClass: "SOM_niv2"
  }, [_c('span', {
    attrs: {
      "href": "#/chap3#niv2-032",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("4. Keep an open door policy.")])]), _vm._v(" "), _c('div', {
    staticClass: "SOM_niv2"
  }, [_c('span', {
    attrs: {
      "href": "#/chap3#niv2-033",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("5. Be prepared to accept and deal with the consequences of that person's actions if he or she does not meet your organization's expectations.")])]), _vm._v(" "), _c('div', {
    staticClass: "SOM_niv2"
  }, [_c('span', {
    attrs: {
      "href": "#/chap3#niv2-034",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("6. Always reward performance.")])]), _vm._v(" "), _c('div', {
    staticClass: "SOM_niv1"
  }, [_c('span', {
    attrs: {
      "href": "#/chap3#niv1-030",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("Dealing with Problem Employees (the “3U” Method)")])]), _vm._v(" "), _c('div', {
    staticClass: "SOM_niv2"
  }, [_c('span', {
    attrs: {
      "href": "#/chap3#niv2-035",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("The Subordinate Interview")])]), _vm._v(" "), _c('div', {
    staticClass: "SOM_niv2"
  }, [_c('span', {
    attrs: {
      "href": "#/chap3#niv2-036",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("The 3U Method")])]), _vm._v(" "), _c('div', {
    staticClass: "SOM_niv1"
  }, [_c('span', {
    attrs: {
      "href": "#/chap3#niv1-031",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("Critiquing Others")])]), _vm._v(" "), _c('div', {
    staticClass: "SOM_niv1"
  }, [_c('span', {
    attrs: {
      "href": "#/chap3#niv1-032",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("The Critiquing Process")])]), _vm._v(" "), _c('div', {
    staticClass: "SOM_niv2"
  }, [_c('span', {
    attrs: {
      "href": "#/chap3#niv2-037",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("1. Begin on a positive.")])]), _vm._v(" "), _c('div', {
    staticClass: "SOM_niv2"
  }, [_c('span', {
    attrs: {
      "href": "#/chap3#niv2-038",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("2. Criticize the act, not the person.")])]), _vm._v(" "), _c('div', {
    staticClass: "SOM_niv2"
  }, [_c('span', {
    attrs: {
      "href": "#/chap3#niv2-039",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("3. Clearly explain what you want (and expect).")])]), _vm._v(" "), _c('div', {
    staticClass: "SOM_niv2"
  }, [_c('span', {
    attrs: {
      "href": "#/chap3#niv2-040",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("4. Develop a solution together and agree on it.")])]), _vm._v(" "), _c('div', {
    staticClass: "SOM_niv2"
  }, [_c('span', {
    attrs: {
      "href": "#/chap3#niv2-041",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("5. End on a positive note.")])]), _vm._v(" "), _c('div', {
    staticClass: "SOM_niv1"
  }, [_c('span', {
    attrs: {
      "href": "#/chap3#niv1-033",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("Freelancing")])]), _vm._v(" "), _c('div', {
    staticClass: "SOM_niv2"
  }, [_c('span', {
    attrs: {
      "href": "#/chap3#niv2-042",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("To illustrate why freelancing is a problem, consider the following scenario.")])]), _vm._v(" "), _c('div', {
    staticClass: "SOM_niv2"
  }, [_c('span', {
    attrs: {
      "href": "#/chap3#niv2-043",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("How to Prevent Freelancing")])]), _vm._v(" "), _c('div', {
    staticClass: "SOM_niv1"
  }, [_c('span', {
    attrs: {
      "href": "#/chap3#niv1-034",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("Mentoring")])]), _vm._v(" "), _c('div', {
    staticClass: "SOM_niv2"
  }, [_c('span', {
    attrs: {
      "href": "#/chap3#niv2-044",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("Qualities of a Good Mentor")])]), _vm._v(" "), _c('div', {
    staticClass: "SOM_niv2"
  }, [_c('span', {
    attrs: {
      "href": "#/chap3#niv2-045",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("What to Look for in a Mentee/Protégé")])]), _vm._v(" "), _c('div', {
    staticClass: "SOM_niv2"
  }, [_c('span', {
    attrs: {
      "href": "#/chap3#niv2-046",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("How to Mentor")])]), _vm._v(" "), _c('div', {
    staticClass: "SOM_niv2"
  }, [_c('span', {
    attrs: {
      "href": "#/chap3#niv2-047",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("Counseling")])]), _vm._v(" "), _c('div', {
    staticClass: "SOM_niv1"
  }, [_c('span', {
    attrs: {
      "href": "#/chap3#niv1-035",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("Improving Morale")])]), _vm._v(" "), _c('div', {
    staticClass: "SOM_niv1"
  }, [_c('span', {
    attrs: {
      "href": "#/chap3#niv1-036",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("Praise and Recognition")])]), _vm._v(" "), _c('div', {
    staticClass: "SOM_niv1"
  }, [_c('span', {
    attrs: {
      "href": "#/chap3#niv1-037",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("Performance Evaluations")])]), _vm._v(" "), _c('div', {
    staticClass: "SOM_niv1"
  }, [_c('span', {
    attrs: {
      "href": "#/chap3#niv1-038",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("Conducting Effective Meetings")])]), _vm._v(" "), _c('div', {
    staticClass: "SOM_niv1"
  }, [_c('span', {
    attrs: {
      "href": "#/chap3#niv1-039",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("Tackling Administrative Tasks and Creating Programs")])]), _vm._v(" "), _c('div', {
    staticClass: "SOM_niv2"
  }, [_c('span', {
    attrs: {
      "href": "#/chap3#niv2-048",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("Step 1: Plan")])]), _vm._v(" "), _c('div', {
    staticClass: "SOM_niv2"
  }, [_c('span', {
    attrs: {
      "href": "#/chap3#niv2-049",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("Step 2: Research")])]), _vm._v(" "), _c('div', {
    staticClass: "SOM_niv2"
  }, [_c('span', {
    attrs: {
      "href": "#/chap3#niv2-050",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("Step 3: Develop")])]), _vm._v(" "), _c('div', {
    staticClass: "SOM_niv2"
  }, [_c('span', {
    attrs: {
      "href": "#/chap3#niv2-051",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("Step 4: Implement")])]), _vm._v(" "), _c('div', {
    staticClass: "SOM_niv2"
  }, [_c('span', {
    attrs: {
      "href": "#/chap3#niv2-052",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("Step 5: Evaluate")])]), _vm._v(" "), _c('div', {
    staticClass: "SOM_niv1"
  }, [_c('span', {
    attrs: {
      "href": "#/chap3#niv1-040",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("Communication and Presentations")])]), _vm._v(" "), _c('div', {
    staticClass: "SOM_niv2"
  }, [_c('span', {
    attrs: {
      "href": "#/chap3#niv2-053",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("Making the Presentation")])]), _vm._v(" "), _c('div', {
    staticClass: "SOM_niv2"
  }, [_c('span', {
    attrs: {
      "href": "#/chap3#niv2-054",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("Communicating in stressful working environments.")])]), _vm._v(" "), _c('div', {
    staticClass: "SOM_chap"
  }, [_c('span', {
    attrs: {
      "href": "#/chap4",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("4 - Customer Service")])]), _vm._v(" "), _c('div', {
    staticClass: "SOM_niv1"
  }, [_c('span', {
    attrs: {
      "href": "#/chap4#niv1-041",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("Culture")])]), _vm._v(" "), _c('div', {
    staticClass: "SOM_niv2"
  }, [_c('span', {
    attrs: {
      "href": "#/chap4#niv2-055",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("Customer Service Model")])]), _vm._v(" "), _c('div', {
    staticClass: "SOM_niv1"
  }, [_c('span', {
    attrs: {
      "href": "#/chap4#niv1-042",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("The Golden Rule")])]), _vm._v(" "), _c('div', {
    staticClass: "SOM_niv1"
  }, [_c('span', {
    attrs: {
      "href": "#/chap4#niv1-043",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("Set the Bar Higher")])]), _vm._v(" "), _c('div', {
    staticClass: "SOM_niv1"
  }, [_c('span', {
    attrs: {
      "href": "#/chap4#niv1-044",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("Dealing with Difficult People")])]), _vm._v(" "), _c('div', {
    staticClass: "SOM_niv1"
  }, [_c('span', {
    attrs: {
      "href": "#/chap4#niv1-045",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("Turn of the Tide")])]), _vm._v(" "), _c('div', {
    staticClass: "SOM_niv1"
  }, [_c('span', {
    attrs: {
      "href": "#/chap4#niv1-046",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("Interpersonal Skills")])]), _vm._v(" "), _c('div', {
    staticClass: "SOM_niv1"
  }, [_c('span', {
    attrs: {
      "href": "#/chap4#niv1-047",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("The First Impression")])]), _vm._v(" "), _c('div', {
    staticClass: "SOM_niv1"
  }, [_c('span', {
    attrs: {
      "href": "#/chap4#niv1-048",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("The Lifeblood of Your Organization")])]), _vm._v(" "), _c('div', {
    staticClass: "SOM_niv1"
  }, [_c('span', {
    attrs: {
      "href": "#/chap4#niv1-049",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("Strive for Excellence")])]), _vm._v(" "), _c('div', {
    staticClass: "SOM_niv1"
  }, [_c('span', {
    attrs: {
      "href": "#/chap4#niv1-050",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("More Than Expected")])]), _vm._v(" "), _c('div', {
    staticClass: "SOM_niv1"
  }, [_c('span', {
    attrs: {
      "href": "#/chap4#niv1-051",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("How to Stand Out")])]), _vm._v(" "), _c('div', {
    staticClass: "SOM_niv1"
  }, [_c('span', {
    attrs: {
      "href": "#/chap4#niv1-052",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("Recognition Book")])]), _vm._v(" "), _c('div', {
    staticClass: "SOM_niv1"
  }, [_c('span', {
    attrs: {
      "href": "#/chap4#niv1-053",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("Social Media")])]), _vm._v(" "), _c('div', {
    staticClass: "SOM_niv1"
  }, [_c('span', {
    attrs: {
      "href": "#/chap4#niv1-054",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("Fireproof Tip")])]), _vm._v(" "), _c('div', {
    staticClass: "SOM_chap"
  }, [_c('span', {
    attrs: {
      "href": "#/chap5",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("5 - Call to Action")])]), _vm._v(" "), _c('div', {
    staticClass: "SOM_niv1"
  }, [_c('span', {
    attrs: {
      "href": "#/chap5#niv1-055",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("Problems Are Opportunities")])]), _vm._v(" "), _c('div', {
    staticClass: "SOM_niv1"
  }, [_c('span', {
    attrs: {
      "href": "#/chap5#niv1-056",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("High-Pressure Decision Making")])]), _vm._v(" "), _c('div', {
    staticClass: "SOM_niv1"
  }, [_c('span', {
    attrs: {
      "href": "#/chap5#niv1-057",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("The Critical Few versus the Insignificant Many")])]), _vm._v(" "), _c('div', {
    staticClass: "SOM_niv1"
  }, [_c('span', {
    attrs: {
      "href": "#/chap5#niv1-058",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("The Dominant Thought")])]), _vm._v(" "), _c('div', {
    staticClass: "SOM_niv1"
  }, [_c('span', {
    attrs: {
      "href": "#/chap5#niv1-059",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("Setting Goals")])]), _vm._v(" "), _c('div', {
    staticClass: "SOM_niv1"
  }, [_c('span', {
    attrs: {
      "href": "#/chap5#niv1-060",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("Goals versus Dreams")])]), _vm._v(" "), _c('div', {
    staticClass: "SOM_niv1"
  }, [_c('span', {
    attrs: {
      "href": "#/chap5#niv1-061",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("The Goal-Setting Strategy")])]), _vm._v(" "), _c('div', {
    staticClass: "SOM_niv1"
  }, [_c('span', {
    attrs: {
      "href": "#/chap5#niv1-062",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("Short-, Mid-, and Long-Range Goals")])]), _vm._v(" "), _c('div', {
    staticClass: "SOM_niv1"
  }, [_c('span', {
    attrs: {
      "href": "#/chap5#niv1-063",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("Ten Goal-Setting Tips")])]), _vm._v(" "), _c('div', {
    staticClass: "SOM_niv1"
  }, [_c('span', {
    attrs: {
      "href": "#/chap5#niv1-064",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("Balance")])]), _vm._v(" "), _c('div', {
    staticClass: "SOM_niv1"
  }, [_c('span', {
    attrs: {
      "href": "#/chap5#niv1-065",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("Trust and Loyalty")])]), _vm._v(" "), _c('div', {
    staticClass: "SOM_niv1"
  }, [_c('span', {
    attrs: {
      "href": "#/chap5#niv1-066",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("Call to Action")])])])])])
}]}


//////////////////
// WEBPACK FOOTER
// ../node_modules/vue-loader/lib/template-compiler?{"id":"data-v-029e4e6e","hasScoped":false,"transformToRequire":{"video":"src","source":"src","img":"src","image":"xlink:href"}}!../node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/components/sommaire.vue
// module id = 69
// module chunks = 0